export default __webpack_public_path__ + "static/media/walkincloset.1767b254.svg";